import { CellProps, VisitCellProps, VisitRequestCellProps } from '@/components/bulkQueue/types';
import { OptionalDateFulfillmentWindowDisplay } from '@/components/fulfillmentWindows/OptionalDateFulfillmentWindowDisplay';
import { NoneLabel } from '@/components/labels/NoneLabel';
import { VerticalStack } from '@/components/utils/linearLayouts';
import { Typography } from '@mui/material';
import moment from 'moment';
import { FC } from 'react';

export const FulfillmentWindowVisitRequestCell: FC<VisitRequestCellProps> = (props) => {
    const { entity } = props;

    if (entity.fulfillmentWindow) {
        return (
            <OptionalDateFulfillmentWindowDisplay
                fulfillmentWindow={entity.fulfillmentWindow}
                label={false}
            />
        );
    }

    return <NoneLabel sx={{ fontSize: '14px' }} />;
};

const FulfillmentWindowVisitCell: FC<VisitCellProps> = (props) => {
    const { fulfillmentWindow } = props.entity;

    if (!fulfillmentWindow) {
        return <NoneLabel sx={{ fontSize: '14px' }} />;
    }

    const { startDatetime, endDatetime } = fulfillmentWindow;
    const startMoment = startDatetime ? moment(startDatetime) : null;
    const endMoment = endDatetime ? moment(endDatetime) : null;

    if (startMoment && endMoment) {
        if (startMoment.isSame(endMoment, 'day')) {
            return <Typography fontSize='14px'>{startMoment.format('MMM D, YYYY')}</Typography>;
        }
        return (
            <VerticalStack>
                <Typography fontSize='14px'>
                    {startMoment.format('MMM D')} - {endMoment.format('MMM D, YYYY')}
                </Typography>
            </VerticalStack>
        );
    }
    if (startMoment) {
        return <Typography fontSize='14px'>After {startMoment.format('MMM D, YYYY')}</Typography>;
    }
    if (endMoment) {
        return <Typography fontSize='14px'>Before {endMoment.format('MMM D, YYYY')}</Typography>;
    }

    return <NoneLabel sx={{ fontSize: '14px' }} />;
};

export const FulfillmentWindowRenderCell: FC<CellProps> = (props) => {
    const { entity } = props;

    switch (entity.__typename) {
        case 'Visit':
            return <FulfillmentWindowVisitCell entity={entity} />;
        case 'VisitRequest':
            return <FulfillmentWindowVisitRequestCell entity={entity} />;
        default:
            return null;
    }
};
